import {
  formatQueryRes,
  getSafeUrl,
  useAppSelector,
  useGetSystemDataQuery,
  useGetUpgradeRoutesQuery,
  useRequestUpgradeMutation
} from '@monorepo/shared';
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Button,
  ButtonToolbar,
  Form,
  FormInstance,
  InputPicker,
  Loader,
  Schema,
  useToaster
} from 'rsuite';
import { ErrorToaster } from './InstanceStatus';
import { ActionConfirm } from '../../components/ActionConfirm';
import { server } from '../../config/const';
import './Views.less';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';

interface IFormValue {
  name: string;
  email: string;
  account_id: string | number;
  instance_id: string;
  // type: string;
  path: string;
}
export const UpgradeTicket = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const data = state?.data || {};
  const toaster = useToaster();
  const { data: systemData } = useGetSystemDataQuery({ server: server });
  const selectData = ['Enterprise', 'Multitenant', 'Cluster'].map((item) => ({
    label: item,
    value: item
  }));
  const [upgradePathData, setUpgradePathData] = useState<Record<string, any>[]>(
    []
  );
  // const deployment_type_note = `
  // 1) FortiSOAR instances have following types
  //     a) Enterprise - Standalone instances with License Type Enterprise
  //     b) Multitenant - Instances with License TypeMultitenant
  //     c) Cluster - Instances that are in HA cluster
  // 2) If you have HA cluster of Multitenant please select Multitenant
  // 3) If your instance is part of cluster please raise separate upgrade request for each system in a cluster`;

  const deployment_type_note = () => {
    return (
      <ol className="type-tooltip ol-list" style={{ padding: '16px' }}>
        <li value={'1'}>{' FortiSOAR instances have following types'}</li>
        <ol className="ol-list">
          <li value={'a'}>
            {'Enterprise - Standalone instances with License Type Enterprise'}
          </li>
          <li value={'b'}>
            {'Multitenant - Instances with License Type Multitenant'}
          </li>
          <li value={'c'}>{'Cluster - Instances that are in HA cluster'}</li>
        </ol>
        <li value={'2'}>
          {'If you have HA cluster of Multitenant please select Multitenant'}
        </li>
        <li value={'3'}>
          {
            'If your instance is part of cluster please raise separate upgrade request for each system in a cluster'
          }
        </li>
      </ol>
    );
  };

  const initFormValue: IFormValue = {
    name: data?.name,
    email: data?.email,
    account_id: data?.account_id,
    instance_id: data?.instance_id,
    // type: '',
    path: ''
  };
  const [requestUpgrade, upgradeResult] = useRequestUpgradeMutation();
  const formRef = useRef<FormInstance>(null);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [formValue, setFormValue] = useState<IFormValue>(initFormValue);
  const [routeMapping, setRouteMapping] = useState<Record<string, any>>({});
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [confirmOpts, setConfirmOpts] = useState<Record<string, any>[]>([]);
  const onSubmit = () => {
    const isValid = formRef.current?.check();
    if (isValid) {
      const requestData = {
        ...formValue,
        instance_id: formValue.instance_id,
        // deployment: formValue.type,
        route_id: formValue.path,
        group_id: currentAccount?.group_id,
        region: data?.region
      };
      requestUpgrade({ ...requestData });
    }
  };

  const {
    data: upgradeRoutesData,
    isError,
    isSuccess,
    isLoading,
    isFetching
  } = useGetUpgradeRoutesQuery(
    formatQueryRes({
      account: currentAccount,
      instance_id: data?.instance_id,
      region: data?.region
    }),
    { skip: !data?.region?.token }
  );
  useEffect(() => {
    if (upgradeRoutesData && upgradeRoutesData.length) {
      const routes = upgradeRoutesData;
      const paths = routes.map((item: Record<string, any>) => ({
        label: item?.from_version
          ? `${item?.from_version} to ${item?.to_version}`
          : data?.firmware
          ? `${data?.firmware} to ${item?.to_version}`
          : `To ${item?.to_version}`,
        value: item?.id
      }));
      const routeMapping = routes.reduce(
        (acc: Record<string, any>, item: Record<string, any>) => {
          acc[item?.id] = item?.from_version
            ? `${item?.from_version} to ${item?.to_version}`
            : data?.firmware
            ? `${data?.firmware} to ${item?.to_version}`
            : `To ${item?.to_version}`;
          return acc;
        },
        {}
      );
      setRouteMapping(routeMapping);
      setUpgradePathData(paths);
    }
  }, [upgradeRoutesData]);
  useEffect(() => {
    if (upgradeResult.error) {
      const data: Record<string, any> = upgradeResult.error;
      const code = data?.error_code || data?.status;
      const messageText =
        data?.error_desc || data?.message || 'Submit Resize Failed!';
      if (messageText) {
        ErrorToaster({
          toaster,
          error: upgradeResult.error,
          title: 'Create Upgrade Request Failed!'
        });
      }
      // } else if (upgradeResult.data) {
    } else if (upgradeResult.isSuccess) {
      setConfirmOpts([
        {
          name: 'Customer Name',
          value: formValue?.name
        },
        {
          name: 'Customer Email ID',
          value: formValue?.email
        },
        {
          name: 'Primary Account ID',
          value: formValue?.account_id
        },
        // {
        //   name: 'Type of Deployment',
        //   value: formValue?.type
        // },
        {
          name: 'Upgrade Path',
          value: `${routeMapping[formValue?.path]}`
        },
        {
          name: 'Instance ID',
          value: formValue?.instance_id
        }
      ]);
      setOpenConfirm(true);
    }
  }, [upgradeResult]);

  const model = Schema.Model({
    // type: Schema.Types.StringType().isRequired('This field is required'),
    path: Schema.Types.StringType().isRequired('This field is required')
  });

  const goToLink = () => {
    if (window && systemData?.product_documentation) {
      window.open(getSafeUrl(systemData?.product_documentation), '_blank');
    }
  };
  const onCancel = () => {
    navigate(-1);
  };
  const FullWidthInputPicker = React.forwardRef((props: any, ref: any) => {
    return <InputPicker {...props} ref={ref} style={{ width: '100%' }} />;
  });
  return (
    <div className="scroll-full-page">
      {upgradeResult.isLoading ? (
        <div style={{ height: '90%', position: 'relative' }}>
          <Loader center size="md" />
        </div>
      ) : (
        <Form
          fluid
          ref={formRef}
          formValue={formValue}
          model={model}
          onChange={(formValue: any) => setFormValue(formValue)}
        >
          <Form.Group controlId="account_name_id">
            <Form.ControlLabel>{'Account Name (Read Only)'}</Form.ControlLabel>
            <Form.Control name="name" placeholder="Account Name" readOnly />
          </Form.Group>
          <Form.Group controlId="account_email_id">
            <Form.ControlLabel>
              {'Account Email ID (Read Only)'}
            </Form.ControlLabel>
            <Form.Control
              name="email"
              type="email"
              placeholder="Email ID"
              readOnly
            />
          </Form.Group>
          <Form.Group controlId="account_id">
            <Form.ControlLabel>
              {'Primary Account ID (Read Only)'}
            </Form.ControlLabel>
            <Form.Control
              name="account_id"
              placeholder="Primary Account ID"
              readOnly
            />
          </Form.Group>
          {/* <Form.Group controlId="deployment_type_id">
            <Form.ControlLabel style={{ display: 'inline-block' }}>
              {'Type of Deployment (Enterprise, Multitenant, Cluster)'}
            </Form.ControlLabel>
            <Form.HelpText
              style={{
                maxWidth: '530px' // Adjust width as needed
              }}
              tooltip
            >
              {deployment_type_note()}
            </Form.HelpText>
            <Form.Control
              name="type"
              accepter={FullWidthInputPicker}
              data={selectData}
              required
            />
          </Form.Group> */}
          <Form.Group controlId="upgrade_path_id">
            <Form.ControlLabel>
              {'Upgrade Path ( Refer'}
              <Button
                appearance="link"
                onClick={goToLink}
                style={{ padding: '2px 6px' }}
              >
                Product Documentation
              </Button>
              {'> Upgrade Path Guide)'}
            </Form.ControlLabel>
            <Form.Control
              name="path"
              accepter={FullWidthInputPicker}
              data={upgradePathData}
              required
            />
          </Form.Group>
          <Form.Group controlId="instance_id">
            <Form.ControlLabel>{'Instance ID (Read Only)'}</Form.ControlLabel>
            <Form.Control
              name="instance_id"
              placeholder="Instance ID"
              readOnly
            />
          </Form.Group>
          <Form.Group>
            <ButtonToolbar>
              <Button appearance="ghost" onClick={onCancel}>
                Cancel
              </Button>
              <Button appearance="primary" onClick={onSubmit}>
                Submit Upgrade Request
              </Button>
            </ButtonToolbar>
          </Form.Group>
        </Form>
      )}
      <ActionConfirm
        open={openConfirm}
        setOpen={setOpenConfirm}
        displayOpts={confirmOpts}
        title={'Your request submitted successfully'}
        onClose={onCancel}
        isCloseBtn={true}
      />
    </div>
  );
};
